// FB motion — scroll reveal only (accordions use clean native <details> + a CSS fade). Bulletproof.
(function(){
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(rm || !('IntersectionObserver' in window)) return;
  function revealAll(){ var n=document.querySelectorAll('.reveal:not(.in)'); for(var i=0;i<n.length;i++) n[i].classList.add('in'); }
  try {
    var sels=['.trust .t','.shead','.carousel','.cats .cat','.story','.promise','.pg>div','.pack','.band','.tech','.collhead','.filters','.grid>.card','.legalhead','.legal','.contactbox','.fgroup'];
    var seen=[];
    sels.forEach(function(s){ document.querySelectorAll(s).forEach(function(el){ if(seen.indexOf(el)<0){ seen.push(el); el.classList.add('reveal'); } }); });
    if(!seen.length) return;
    document.documentElement.classList.add('fbanim');
    ['.trust .row','.cats','.pg','.grid'].forEach(function(g){
      document.querySelectorAll(g).forEach(function(grp){
        Array.prototype.slice.call(grp.children).forEach(function(c,i){ if(c.classList && c.classList.contains('reveal')) c.style.transitionDelay=(i*0.08)+'s'; });
      });
    });
    var io=new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } }); }, {threshold:0.06, rootMargin:'0px 0px -5% 0px'});
    seen.forEach(function(el){ io.observe(el); });
    requestAnimationFrame(function(){ seen.forEach(function(el){ if(el.getBoundingClientRect().top < window.innerHeight*1.05) el.classList.add('in'); }); });
    setTimeout(revealAll, 1400);
    window.addEventListener('load', function(){ setTimeout(revealAll, 600); });
  } catch(e){ revealAll(); }
})();
